module.exports = __webpack_public_path__ + "img/articles1.jpg?816d4c6d53c758f924bea0a7966ba76b";